import(/* webpackMode: "eager", webpackExports: ["Desktop"] */ "/opt/build/repo/src/app/mac-os-classic/Desktop.tsx");
